<template>
  <div class="tile is-ancestor is-parent">
    <div class="tile is-parent">
      <article class="tile is-child p-4">
        <div>
          <!-- <h6 class="title is-6">Select Document Attachments</h6> -->
          <div v-if="isLoading > 0"
            class="section">
            <span class="is-loading-image has-text-grey has-text-centered" />
          </div>
          <div v-else>
            <div v-for="category in categoryAttachments"
              :key="category.quoteAttachmentCategoryId"
              style="margin-bottom: 1em;">
              <h6 class="title is-6">{{ category.name }}</h6>

              <div class="columns is-multiline">
                <div v-for="attachment in category.attachments"
                  :key="attachment.quoteAttachmentId"
                  class="column is-1 m-0 p-1">
                  <!-- <input type="checkbox"
                      :value="attachment"
                      v-model="selectedAttachments"
                      :disabled="maxSelected > 0 && selectedAttachments.length >= maxSelected && !isSelected(attachment)"
                      style="margin-right: 0.5em;"> -->
                  <quote-attachment
                    :attachment="attachment"
                    :quote-id="quoteId"
                    :quote-attachment-id="attachment.quoteAttachmentId"
                    :quote-attachment-category-id="category.quoteAttachmentCategoryId"
                    :categories="categories"
                    @update:attachment="onUpdateAttachment"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import QuoteService from '@/views/quote/QuoteService'
import _cloneDeep from 'lodash/cloneDeep'
import QuoteAttachment from './QuoteAttachment.vue'

export default {
  name: 'AttachmentSelect',
  components: { QuoteAttachment },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    quoteId: {
      type: String,
      default: ''
    },
    maxSelected: {
      type: Number,
      default: 0 // 0 = unlimited
    }
  },
  data() {
    return {
      categories: [],
      selectedAttachments: [],
      isLoading: 0
    }
  },
  computed: {
    categoryAttachments() {
      return this.categories.map(category => {
        return {
          ...category,
          attachments: (category.attachments || []).map(attachment => ({
            ...attachment,
            isSelected: this.selectedAttachments.some(
              selected => selected.quoteAttachmentId === attachment.quoteAttachmentId
            )
          }))
        }
      })
    }
  },
  watch: {
    selectedAttachments: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  created() {
    this.selectedAttachments = this.value
    this.getQuoteAttachmentCategories()
  },
  methods: {
    isSelected(attachment) {
      return this.selectedAttachments.some(a => a.quoteAttachmentId === attachment.quoteAttachmentId)
    },
    onUpdateAttachment({ attachment, isSelected }) {
      // Update the attachment in categories first
      this.categories.forEach(category => {
        const categoryAttachment = category.attachments.find(
          att => att.quoteAttachmentId === attachment.quoteAttachmentId
        )
        if (categoryAttachment) {
          categoryAttachment.isSelected = isSelected
        }
      })

      // Then handle selectedAttachments array
      if (isSelected) {
        // Only add if not already present (no duplicate)
        if (!this.selectedAttachments.some(a => a.quoteAttachmentId === attachment.quoteAttachmentId)) {
          this.selectedAttachments.push({
            ...attachment,
            isSelected: true
          })
        }
      } else {
        const idx = this.selectedAttachments.findIndex(a => a.quoteAttachmentId === attachment.quoteAttachmentId)
        if (idx !== -1) this.selectedAttachments.splice(idx, 1)
      }
    },
    async getQuoteAttachmentCategories() {
      this.isLoading++
      const response = await QuoteService.getQuoteAttachmentCategories()
      this.categories = _cloneDeep(response)
      await this.getQuoteAttachments()
      this.isLoading--
    },
    async getQuoteAttachments() {
      if (!this.quoteId) return
      const response = await QuoteService.getQuoteAttachments(this.quoteId)
      const attachmentsByCat = response.data
      // Map attachments to categories
      for (let category of this.categories) {
        const catData = attachmentsByCat[category.quoteAttachmentCategoryId]
        if (catData && catData.quoteAttachments) {
          category.attachments = Object.values(catData.quoteAttachments)
        } else {
          category.attachments = []
        }
      }
    }
  }
}
</script>
